












import { Component, Vue } from 'vue-property-decorator'

import { Meta } from '@/helpers/decorators'
import ReportsList from '@/views/reports/list/ReportsList.vue'
import Tabs from '@/components/common/Tabs.vue'

@Component({
  components: {
    ReportsList,
    Tabs
  }
})
export default class ListAllReports extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.reports'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
